import { defineComponent as _defineComponent } from 'vue'
import YagiofferSelfPrAppendBox from '@/components/yagioffer/YagiofferSelfPrAppendBox.vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoAiMypr } from '@/composables/format-edit/useNewRirekishoAiMypr'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoAiMyprCard',
  props: {
    currentCardId: null,
    previewErrors: null,
    textareaMinRows: null
  },
  setup(__props: any) {



const { globalVar } = useHostServices()
const formatData = useNewRirekishoFormatData()
const {
  fullscreenLoading,
  aiResultView,
  aiCampusHistoryResult,
  aiGakuchikaResult,
  getAIMyprNew,
  viewPaymentYagiprime,
  applyGeneratedPr
} = useNewRirekishoAiMypr(formatData)

return { __sfc: true,globalVar, formatData, fullscreenLoading, aiResultView, aiCampusHistoryResult, aiGakuchikaResult, getAIMyprNew, viewPaymentYagiprime, applyGeneratedPr, YagiofferSelfPrAppendBox }
}

})